<template>
<b-overlay :show="isLoadedNewKeys">
  <b-tabs content-class="mt-3">
    <b-tab title="Text" active>
      <b-tabs pills card vertical>
        <!-- Render Tabs, supply a unique `key` to each tab -->
        <b-tab
          @click="tabClick(language)"
          v-for="(language, index) in form.formTranslations"
          :key="index"
          :title="language"
        >
          <!-- translation form wrappe -->
          <div>
            <b-form-group label="Label">
              <b-form-input
                @blur="addLanguageToField(language)"
                v-model="label"
                :placeholder="fieldData.label[transalationLanguage]"
                type="text"
              ></b-form-input>
            </b-form-group>
            <b-spinner small v-if="isLoadedNewKeys"></b-spinner>
            <div v-else>
              <b-form-group
                label="Abbreviation Label"
                v-if="fieldData.abbreviationLabelText"
              >
                <b-form-input
                  @blur="addLanguageToField(language)"
                  v-model="
                    fieldData.abbreviationLabelText[transalationLanguage]
                  "
                  type="text"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="Text for table"
                v-if="fieldData.labelForTable"
              >
                <b-form-input
                  @blur="addLanguageToField(language)"
                  v-model="fieldData.labelForTable[transalationLanguage]"
                  type="text"
                ></b-form-input>
                <!-- maxlength="25" -->
              </b-form-group>
            </div>
            <b-form-group label="Helper Text">
              <b-form-textarea
                @blur="addLanguageToField(language)"
                v-model="helperText"
                :placeholder="fieldData.helperText[transalationLanguage]"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group label="Validation Message">
              <b-form-input
                @blur="addLanguageToField(language)"
                v-model="validationMessage"
                :placeholder="fieldData.validationMessage[transalationLanguage]"
                type="text"
              ></b-form-input>
            </b-form-group>

            <!-- advance hyper link  -->
            <b-form-checkbox v-model="fieldData.isHyperLink"
              >Enable Hyper link</b-form-checkbox
            >
            <b-collapse v-model="fieldData.isHyperLink">
              <b-form-group v-if="fieldData.hyperLinkUrl" label="Hyper Link Url">
                <b-form-input
                  @blur="addLanguageToField(language)"
                  v-model="fieldData.hyperLinkUrl[transalationLanguage]"
                  placeholder="wwww.google.com"
                ></b-form-input>
              </b-form-group>
              <b-form-group v-if="fieldData.hyperLinkText" label="Hyper Link Text">
                <b-form-input
                  @blur="addLanguageToField(language)"
                  v-model="fieldData.hyperLinkText[transalationLanguage]"
                  placeholder="click on the link"
                ></b-form-input>
              </b-form-group>
              <b-form-group v-if="fieldData.hyperLinkTextBefore" label="Text before Hyper Link">
                <b-form-input
                  @blur="addLanguageToField(language)"
                  v-model="fieldData.hyperLinkTextBefore[transalationLanguage]"
                  placeholder=""
                ></b-form-input>
              </b-form-group>
              <b-form-group v-if="fieldData.hyperLinkTextAfter" label="Text after Hyper Link">
                <b-form-input
                  @blur="addLanguageToField(language)"
                  v-model="fieldData.hyperLinkTextAfter[transalationLanguage]"
                  placeholder=""
                ></b-form-input>
              </b-form-group>
            </b-collapse>

            <b-form-checkbox
              v-if="fieldData.inputType != 'checkbox' || 'radio'"
              v-model="isStacked"
              >Is Stacked?</b-form-checkbox
            >
          </div>

          <!-- <b-button
						class="btn btn-primary mt-3"
						@click="addLanguageToField(language)"
						variant="primary"
          >Update</b-button>-->
        </b-tab>
      </b-tabs>
    </b-tab>

    <!-- for charts enable and disable -->
    <b-tab
      title="Configure"
      v-if="
        fieldData.inputType == 'radio' ||
        fieldData.inputType == 'select' ||
        fieldData.inputType == 'countries' ||
        fieldData.inputType == 'cpi-countries' ||
        fieldData.inputType == 'checkbox' ||
        fieldData.inputType == 'currency'
      "
    >
      <b-form-group
        v-if="fieldData.inputType == 'countries'"
        label="Selec County List Type"
      >
        <v-select
          searchable
          clearable
          label="text"
          value="text"
          :options="renderOptions"
          v-model="fieldData.selectedListTypeIndex"
        ></v-select>
      </b-form-group>

      <!-- <div v-if="fieldData.inputType == 'checkbox'">
        <b-form-checkbox v-model="fieldData.customScoring">Enable custom scoring</b-form-checkbox>
        <b-collapse :visible="fieldData.customScoring">
          <b-form-group label="Please selece one">
            <b-form-radio
              v-model="fieldData.customScoringType"
              name="some-radios"
              value="0"
            >1 or more topics selected is 0</b-form-radio>
            <b-form-radio
              v-model="fieldData.customScoringType"
              name="some-radios"
              value="1"
            >1 - 3 selected is 0.5</b-form-radio>
          </b-form-group>
        </b-collapse>

        <b-form-group v-if="fieldData.inputType == 'checkbox'" label="Disable options when">
          <v-select
            searchable
            clearable
            multiple
            label="value"
            value="value"
            :options="fieldData.options"
            v-model="fieldData.disableOptions"
          ></v-select>
        </b-form-group>
      </div>-->

      <b-form-group label="Enter Weightage (in %)">
        <b-form-input
          no-wheel
          placeholder="0"
          max="2"
          maxlength="2"
          trim
          onkeydown="return (event.keyCode >= 46 && event.keyCode <= 57) || event.keyCode == 8"
          v-model="fieldData.weightage"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Select Grphical Representaton for Data">
        <b-form-radio-group
          stacked
          v-model="fieldData.selectedCharts"
          id="checkbox-group-1"
          :options="optionsCharts"
        ></b-form-radio-group>
      </b-form-group>
    </b-tab>

    <b-tab
      title="Conditional Field Text"
      v-if="fieldData.enabledConditionalField == 1"
    >
      <b-tabs pills card vertical>
        <b-tab
          @click="tabClick(language)"
          v-for="(language, index) in form.formTranslations"
          :key="index"
          :title="language"
        >
          <div>
            <b-form-group label="Conditional Field">
              <b-form-input
                @blur="addLanguageToField(language)"
                v-model="conditionalFieldLabel"
                :placeholder="
                  fieldData.conditionalFieldLabel[transalationLanguage]
                "
                type="text"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Conditional Field Placeholder Text">
              <b-form-input
                @blur="addLanguageToField(language)"
                v-model="conditionalFieldPlaceHolderText"
                :placeholder="
                  fieldData.conditionalFieldPlaceHolderText[
                    transalationLanguage
                  ]
                "
                type="text"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Conditional Field Helper Text">
              <b-form-textarea
                @blur="addLanguageToField(language)"
                v-model="conditionalFieldHelperText"
                :placeholder="
                  fieldData.conditionalFieldHelperText[transalationLanguage]
                "
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
            <!-- <b-form-group label="Conditional Field Validation Message">
              <b-form-input
                @blur="addLanguageToField(language)"
                v-model="conditionalFieldValidationMessage"
                :placeholder="
                  fieldData.conditionalFieldValidationMessage[
                    transalationLanguage
                  ]
                "
                type="text"
              ></b-form-input>
            </b-form-group> -->
          </div>
        </b-tab>
      </b-tabs>
    </b-tab>

    <!-- options tabb -->
    <b-tab
      title="Options"
      v-if="
        fieldData.inputType == 'radio' ||
        fieldData.inputType == 'select' ||
        fieldData.inputType == 'checkbox' ||
        fieldData.inputType == 'currency'
      "
    >
      <!-- select options tab -->
      <b-tabs pills card vertical>
        <b-tab
          @click="tabClick(language)"
          v-for="(language, index) in form.formTranslations"
          :key="index"
          :title="language"
        >
          <b-form @submit.stop.prevent class="active text-left mt-2">
            <table class="table table-sm">
              <thead>
                <tr class="text-center">
                  <th>Option text</th>
                  <th>Value</th>
                  <th>Score</th>
                  <th>Abbrivation Text</th>
                  <th
                    v-for="(colOpt, colThIndex) in customColumnsForOptions"
                    :key="colThIndex"
                  >
                    {{ colOpt.text }}
                    <b-button
                      v-if="customColumnsForOptions.length"
                      variant="outline-danger"
                      class="btn btn-outline-danger btn-sm"
                      @click="onDeleteCol(colThIndex)"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </th>

                  <th>
                    <b-button
                      class="btn-sm"
                      variant="primary"
                      v-b-modal.modal-new-col
                    >
                      <i class="fa fa-plus"></i>
                    </b-button>
                  </th>

                  <!-- <th>weightage(in %)</th> -->
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(option, optionIndex) in fieldData.options"
                  :key="optionIndex"
                >
                  <td>
                    <b-form-input
                      :value="option.text[transalationLanguage]"
                      @input="setFieldOptionText($event, optionIndex)"
                      @focus="$event.target.select()"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      :disabled="transalationLanguage !== 'english'"
                      :value="option.value"
                      @input="setFieldOptionValue($event, optionIndex)"
                      @focus="$event.target.select()"
                    ></b-form-input>
                  </td>
                  <td>
                    <!-- @input="optionValue = $event" -->

                    <b-form-input
                      placeholder="0"
                      no-wheel
                      onkeydown="return event.keyCode !== 69"
                      type="number"
                      trim
                      v-model="option.score"
                    ></b-form-input>
                  </td>
                  <td v-if="option.postValueAbb">
                    <b-form-input
                      :value="option.postValueAbb[transalationLanguage]"
                      v-model="option.postValueAbb[transalationLanguage]"
                      @focus="$event.target.select()"
                    ></b-form-input>
                  </td>

                  <td
                    v-for="(col, colIndex) in customColumnsForOptions"
                    :key="colIndex"
                  >
                    <b-form-input
                      v-model="option.custom_values[col.key]"
                    ></b-form-input>
                  </td>

                  <!-- <td>

                    <b-form-input
                      no-wheel
                      placeholder="0"
                      max="2"
                      maxlength="2"
                      trim
                      onkeydown="return (event.keyCode >= 46 && event.keyCode <= 57) || event.keyCode == 8" 
                      v-model="option.weightage"
                    ></b-form-input>
                  </td>-->
                  <td>
                    <!-- v-if="optionIndex > 1" -->

                    <b-button
                      variant="outline-danger"
                      class="btn btn-outline-danger btn-sm"
                      @click="onDeleteOption(optionIndex)"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>

            <b-button variant="primary" @click="addOption">
              <i class="fa fa-plus"></i>
            </b-button>
            <br />
            <!-- <b-button
              variant="primary"
              @click="addLanguageToFieldOptions(language, optionIndex)"
              class="mt-3"
            >Update</b-button>-->
          </b-form>
        </b-tab>
      </b-tabs>
    </b-tab>

    <!-- attribute tab -->
    <b-tab title="Attributes">
      <b-form @submit.stop.prevent class="text-left mt-2">
        <div class="form-group col-md-6">
          <label for>ID</label>
          <b-form-input v-model="selectId"></b-form-input>
        </div>
        <div class="form-group col-md-6">
          <label for>Class</label>
          <b-form-input v-model="selectClass"></b-form-input>
        </div>
        <div class="form-group col-md-6">
          <label for>Title</label>
          <b-form-input v-model="selectTitle"></b-form-input>
        </div>
        <div class="form-group col-md-6">
          <label for>Post Name</label>
          <b-form-input v-model="selectedPostName"></b-form-input>
        </div>
        <div class="form-group col-md-6">
          <label for>style</label>
          <b-form-textarea
            id="textarea"
            v-model="selectStyle"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </div>
        <div class="form-check">
          <b-form-checkbox
            id="checkbox-1"
            v-model="selecReadOnly"
            name="checkbox-1"
            >Readonly</b-form-checkbox
          >
        </div>
        <div class="form-check">
          <b-form-checkbox
            id="checkbox-4"
            value="1"
            v-model="fieldData.enableSelfReportingForThirdPartyProfile"
            >Show Self Reporting Data in Third Party Profile</b-form-checkbox
          >
        </div>
        <div class="form-check">
          <b-form-checkbox
            id="checkbox-5"
            value="1"
            unchecked-value="0"
            v-model="fieldData.enableSelfReportingForManageThirdParty"
            name="checkbox-5"
            >Show Self Reporting Data in Mangage Third Party</b-form-checkbox
          >
        </div>
        <div class="form-check">
          <b-form-checkbox
            id="checkbox-6"
            value="1"
            unchecked-value="0"
            v-model="fieldData.enableFilterForManageThirdParty"
            name="checkbox-5"
            >Filter in Mangage Third Party</b-form-checkbox
          >
        </div>
        <!-- <button class="btn btn-primary ml-3 mt-3" @click="addAttributes">Update</button> -->
      </b-form>
    </b-tab>

    <!-- data tab -->
    <b-tab title="Data">
      <table class="table table-sm">
        <thead>
          <tr>
            <th></th>
            <th>Key</th>
            <th>Value</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(attribute, index) in fieldData.dataAttributes"
            :key="index"
          >
            <td class="text-right align-middle">data-</td>
            <td>
              <b-form-input v-model="attribute.dataAttributeKey"></b-form-input>
            </td>
            <!-- @input="dataAttributeKey = $event" -->
            <!-- @input="dataAttributeValue = $event"  -->
            <td>
              <b-form-input
                v-model="attribute.dataAttributeValue"
              ></b-form-input>
            </td>
            <td>
              <button
                class="btn btn-danger btn-sm"
                @click="onDeleteDataAttribute(index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-primary btn-sm" @click="addDataAttribute">
        <i class="fa fa-plus"></i>
      </button>
    </b-tab>

    <!-- data validation -->
    <b-tab title="Validation">
      <div class="text-left">
        <b-col>
          <b-form-checkbox
            class="form-group col-md-6 ml-3"
            v-model="isRequireCheck"
            value="1"
            unchecked-value="0"
            >Is required?</b-form-checkbox
          >
        </b-col>
        <b-col v-if="fieldData.inputType === 'checkbox'">
          <div class="form-group col-md-6">
            <label>Minimum Selects</label>
            <b-form-input type="number" v-model="minSelect"></b-form-input>
          </div>
          <div class="form-group col-md-6">
            <label for>Maximum Selects</label>
            <b-form-input type="number" v-model="maxSelect"></b-form-input>
          </div>
        </b-col>

        <!-- <b-button
					class="btn btn-primary mt-3"
					@click="setValidation"
					variant="primary"
					:disabled="isLoading"
        >Update</b-button>-->
      </div>
    </b-tab>

    <!-- Advance for select only -->
    <b-tab
      title="Advanced"
      v-if="
        fieldData.inputType == 'select' ||
        fieldData.inputType == 'countries' ||
        fieldData.inputType == 'currency' ||
        fieldData.inputType == 'titles' ||
        fieldData.inputType == 'cpi-countries'
      "
    >
      <div class="text-left">
        <b-col cols="6">
          <b-form-group>
            <b-form-checkbox class="mt-2" v-model="isMultipleSelect"
              >Allow Multiple Selection</b-form-checkbox
            >
          </b-form-group>
        </b-col>
        <b-row v-if="isMultipleSelect" class="ml-1">
          <b-col cols="4">
            <b-form-group label="Minimum number of selection">
              <b-form-input
                type="number"
                v-model="minSelection"
                placeholder="0"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group label="Maximum number of selection">
              <b-form-input
                type="number"
                v-model="maxSelection"
                placeholder="0"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-col cols="6">
          <b-form-group>
            <b-form-checkbox class="mt-2" v-model="isLiveSearchable"
              >Enable Live Search</b-form-checkbox
            >
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <b-form-checkbox class="mt-2" v-model="isClearable"
              >Clearable</b-form-checkbox
            >
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Number of options to be displayed">
            <b-form-input
              type="number"
              v-model="renderOptionsLinmit"
              placeholder="0"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <!-- <b-button
					class="btn btn-primary mt-3 ml-3"
					@click="setAdvanceSettingsForSelect"
					variant="primary"
					:disabled="isLoading"
				>
					<b-spinner small v-if="isLoading"></b-spinner>Update
        </b-button>-->
      </div>
    </b-tab>

    <!-- --------------Conditional------------------ -->
    <b-tab title="Conditional">
      <b-tabs>
        <!-- Render Tabs, supply a unique `key` to each tab -->
        <b-tab
          title="Simple"
          v-if="
            fieldData.inputType == 'radio' ||
            fieldData.inputType == 'select' ||
            fieldData.inputType == 'checkbox'
          "
        >
          <b-col>
            <!-- enabledConditionalField -->
            <b-form-checkbox
              class="text-left"
              value="1"
              unchecked-value="0"
              @change="onToggleConditionalCheck"
              v-model="enabledConditionalField"
              >Enable Conditional Field</b-form-checkbox
            >

            <b-collapse v-model="showCollapseRadios" class="mt-2">
              <b-form-group class="my-3">
                <b-form-radio
                  @change="onShowHideSelect"
                  v-model="selectedShowHide"
                  value="1"
                  >Show when selected option value is:</b-form-radio
                >
              </b-form-group>
              <b-form-select
                v-show="selectedShowHide == 1"
                v-model="selectedConditionalFieldValue"
                text-field="value"
                @change="onSelectConditionOption"
                :options="fieldData.options"
              ></b-form-select>

              <!-- temparory hide for multi progressive conditionals -->
              <!-- <b-form-group
                v-show="selectedShowHide == 1 && fieldData.selectedConditionalFieldValue"
                label="Number of inputs show?"
              >
                <b-form-radio-group
                  v-model="selectedMutiInputs"
                  @input="onSelectConditionOption"
                  :options="optionsMutiInputs"
                ></b-form-radio-group>
              </b-form-group>-->
            </b-collapse>
          </b-col>
        </b-tab>
        <!--           v-if="fieldData.inputType == 'radio' 
        || fieldData.inputType == 'checkbox'"-->
        <b-tab title="Advance">
          <b-col cols="12" class="mr-0">
            <b-form-checkbox
              v-model="isConditional"
              name="conditional"
              value="1"
              unchecked-value="0"
              >Is Conditional?</b-form-checkbox
            >

            <div v-if="isConditional == 1">
              <b-row>
                <table class="table table-sm">
                  <thead>
                    <tr class="text-center">
                      <th>No</th>
                      <th>When Field</th>
                      <th>Has Value</th>
                      <th>Actions</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(selectedOpt, index) in fieldData.conditions"
                      :key="selectedOpt.id"
                    >
                      <td>{{ index }}</td>
                      <td>
                        <b-form-input disabled :value="selectedOpt.label" />
                      </td>
                      <td>
                        <b-form-input disabled :value="selectedOpt.value" />
                      </td>
                      <td>
                        <b-button
                          variant="outline-danger"
                          class="btn-sm ml-1"
                          @click="onRemoveConditionOpt(selectedOpt.id, index)"
                        >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </td>
                    </tr>

                    <tr
                      v-for="(noOfOption, index) in noOfConditions"
                      :key="index"
                    >
                      <td>{{ fieldData.conditions.length }}</td>
                      <td>
                        <v-select
                          v-model="conditionalField"
                          class="mb-2"
                          :options="conditionalSectionElementLables"
                          lablel="label"
                          @input="getSelectedElement"
                        ></v-select>
                      </td>
                      <td>
                        <v-select
                          class="mb-2"
                          label="text"
                          v-model="conditionalFieldValue"
                          :options="selectedElementOption"
                        ></v-select>
                      </td>

                      <td>
                        <b-button
                          class="btn-sm"
                          variant="outline-primary"
                          @click="setFieldConditions"
                          >Apply</b-button
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-row>
            </div>
          </b-col>
        </b-tab>
      </b-tabs>
    </b-tab>

    <!-- Ranges tabb -->
    <b-tab
      title="Ranges"
      v-if="
        fieldData.inputType == 'select' ||
        fieldData.inputType == 'checkbox' ||
        fieldData.inputType == 'currency'
      "
    >
      <b-form @submit.stop.prevent class="active text-left mt-2">
        <table class="table table-sm">
          <thead>
            <tr class="text-center">
              <th>Min Count</th>
              <th>Max Count</th>
              <th>Score</th>
              <th></th>
            </tr>
          </thead>
          <b-spinner v-if="isRangeCreating"></b-spinner>
          <tbody v-else>
            <tr v-for="(attribute, index) in fieldData.ranges" :key="index">
              <td>
                <b-form-input
                  type="number"
                  v-model="attribute.minRange"
                ></b-form-input>
              </td>
              <td>
                <b-form-input
                  type="number"
                  v-model="attribute.maxRange"
                ></b-form-input>
              </td>
              <td>
                <b-form-input
                  type="number"
                  v-model="attribute.score"
                ></b-form-input>
              </td>
              <td>
                <button
                  class="btn btn-danger btn-sm"
                  @click="onDeleteRange(index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <b-button variant="primary" @click="addRangeOption">
          <i class="fa fa-plus"></i>
        </b-button>
        <br />
      </b-form>
    </b-tab>

    <!-- condirional -->
    <b-modal @ok="addColumnToOption" id="modal-new-col" title="Add New Col">
      <b-form-group label="Enter Column Text">
        <b-form-input v-model="newColData.text"></b-form-input>
      </b-form-group>
      <b-form-group trim label="Enter key">
        <b-form-input v-model="newColData.key"></b-form-input>
      </b-form-group>
      <b-form-group label="Description">
        <b-form-input v-model="newColData.desc"></b-form-input>
      </b-form-group>
    </b-modal>
  </b-tabs>
</b-overlay>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { EventBus } from "@/event-bus.js";
import uid from "uid";
import { Helper } from "../helpers";
import _ from "lodash";

export default {
  name: "AdvanceRadioSettings",
  data() {
    return {
      isHyperLink: false,
      isLoadedNewKeys: false,
      isRangeCreating: false,
      customColumnsForOptions: [],
      newColData: {
        text: null,
        key: null,
        desc: null,
        value: null,
      },
      conditionalFieldLabel: null,
      conditionalFieldPlaceHolderText: null,
      conditionalFieldHelperText: null,
      conditionalFieldValidationMessage: null,
      conditionalFieldFirstLabel: null,
      conditionalFieldYesLabel: null,
      conditionalFieldNoLabel: null,
      isStacked: true,
      fieldCSS: null,
      fieldJS: null,
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: "Text/Css",
        theme: "Paraiso-Light",
        lineNumbers: true,
        line: true,
        height: 500,
      },
      // multi progressive
      optionsMutiInputs: [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
      ],
      renderOptions: [
        { text: "Default", value: "0" },
        { text: "Modern Slavery Indigenious", value: "1" },
        { text: "Modern Slavery without Indigenious", value: "2" },
      ],
      selectedMutiInputs: 1,

      //  for charts

      selectedCharts: [],
      optionsCharts: [
        { text: "None", value: null },
        { text: "Line", value: "line" },
        { text: "Bar", value: "bar" },
        { text: "Pie", value: "pie" },
        { text: "Area", value: "area" },
        { text: "Column", value: "column" },
        { text: "Scatter", value: "scatter" },
        { text: "Pyramid", value: "pyramid" },
        { text: "Funnel", value: "funnel" },
        { text: "Columnpyramid", value: "columnpyramid" },
        { text: "Country Map", value: "countrymap" },
      ],

      // advance condition
      conditionalSectionElements: [],
      conditionalSectionElementLables: [],
      selectedElementOption: [],
      conditionalField: null,
      conditionalFieldValue: null,
      condition: {},
      isConditional:
        this.fieldData.isConditional && this.fieldData.conditions.length,
      noOfConditions: [1],

      isLoading: false,
      transalationLanguage: "english",
      label: undefined,
      placeholder: undefined,
      validationMessage: undefined,
      helperText: undefined,
      optiponName: undefined,
      optionValue: undefined,
      dataAttributeValue: undefined,
      dataAttributeKey: undefined,
      isRequireCheck:
        this.fieldData.validation && this.fieldData.validation.required,
      validityMessage:
        this.fieldData.validation && this.fieldData.validation.message
          ? this.fieldData.validation.message
          : "This field is required",
      selectId:
        this.fieldData.attributes && this.fieldData.attributes.newId
          ? this.fieldData.attributes.newId
          : undefined,
      selectClass:
        this.fieldData.attributes && this.fieldData.attributes.Class
          ? this.fieldData.attributes.Class
          : undefined,
      selectTitle:
        this.fieldData.attributes && this.fieldData.attributes.Title
          ? this.fieldData.attributes.Title
          : undefined,
      selectedPostName:
        this.fieldData.attributes && this.fieldData.attributes.postName
          ? this.fieldData.attributes.postName
          : undefined,

      selectStyle:
        this.fieldData.attributes && this.fieldData.attributes.Style
          ? this.fieldData.attributes.Style
          : undefined,
      selecReadOnly:
        this.fieldData.attributes && this.fieldData.attributes.readonly
          ? this.fieldData.attributes.readonly
          : false,
      showTab: "text",

      // advance tab settings for select only

      isMultipleSelect:
        (this.fieldData.configuration &&
          this.fieldData.configuration.isMultipleSelect) ||
        false,
      isClearable:
        (this.fieldData.configuration &&
          this.fieldData.configuration.isClearable) ||
        false,
      isLiveSearchable:
        (this.fieldData.configuration &&
          this.fieldData.configuration.isLiveSearchable) ||
        false,
      minSelection:
        (this.fieldData.configuration &&
          this.fieldData.configuration.minSelection) ||
        1,
      maxSelection:
        (this.fieldData.configuration &&
          this.fieldData.configuration.maxSelection) ||
        2,
      renderOptionsLinmit:
        (this.fieldData.configuration &&
          this.fieldData.configuration.renderOptionsLinmit) ||
        5,

      // advance tab settings for checkbox
      minSelect: this.fieldData.validation.minSelect,
      maxSelect: this.fieldData.validation.maxSelect,

      // for conditional filedsss
      enabledConditionalField: 0,
      showCollapseRadios: false,
      selectedShowHide: null,
      selectedConditionalFieldValue: null,
    };
  },
  computed: {
    ...mapGetters({ form: "form1" }),
  },

  created() {
    EventBus.$on("onSaveSettings", (value) => {
      // console.log("onSaveSettings", value);
      this.addLanguageToField(this.transalationLanguage);
      this.addAttributes();
      this.setValidation();
      this.setAdvanceSettingsForSelect();
      this.setCustomColOptionsToSchema();
      // this.addLanguageToProgressiveField(this.transalationLanguage)
    });
  },

  mounted() {
    this.addExtras();
    (this.isStacked = this.fieldData.configuration.isStacked),
      (this.label = this.fieldData.label[this.transalationLanguage]),
      (this.validationMessage = this.fieldData.validationMessage[
        this.transalationLanguage
      ]),
      (this.helperText = this.fieldData.helperText[this.transalationLanguage]);
    this.helperText = this.fieldData.helperText[this.transalationLanguage];

    // Conditional Field
    if (
      this.fieldData.inputType == "radio" ||
      this.fieldData.inputType == "select" ||
      this.fieldData.inputType == "checkbox"
    ) {
      this.addNewKeyToOptions(); // to add weightage
      this.enabledConditionalField = this.fieldData.enabledConditionalField;
      this.selectedShowHide = this.fieldData.conditionalShowHiddenOption;
      this.showCollapseRadios =
        this.enabledConditionalField == 1 ? true : false;
      this.selectedConditionalFieldValue = this.fieldData.selectedConditionalFieldValue;
      this.selectedMutiInputs = this.fieldData.selectedMutiInputs;
      this.conditionalFieldLabel = this.fieldData.conditionalFieldLabel[
        this.transalationLanguage
      ];
      this.conditionalFieldPlaceHolderText = this.fieldData.conditionalFieldPlaceHolderText[
        this.transalationLanguage
      ];

      this.conditionalFieldValidationMessage = this.fieldData.conditionalFieldValidationMessage[
        this.transalationLanguage
      ];
      this.conditionalFieldHelperText = this.fieldData.conditionalFieldHelperText[
        this.transalationLanguage
      ];
    }
    this.addExtras();
    this.addExtrasForHyperLink();
    this.getCurrentSectionList();
    if (!this.fieldData.ranges) {
      this.addRangesToSchema();
    }
    this.getCustomColOptionsFromSchema();
  },

  methods: {
    ...mapMutations(["TOGGLE_LOADER"]),
     addExtras() {
      this.isLoadedNewKeys = true;
      let self = this;
      if (!this.fieldData.abbreviationLabelText) {
        let abbreviationLabelText = { english: " " };
        Object.assign(this.fieldData, { abbreviationLabelText });
      }
      if (!this.fieldData.labelForTable) {
        let labelForTable = { english: "" };
        Object.assign(this.fieldData, { labelForTable });
      }
      if (!this.fieldData.headerText) {
        let headerText = { english: "" };
        Object.assign(this.fieldData, { headerText });
      }
      if (!this.fieldData.footerText) {
        let footerText = { english: "" };
        Object.assign(this.fieldData, { footerText });
      }
      setTimeout(function () {
        self.isLoadedNewKeys = false;
      }, 1000);
    },

    addExtras() {
      this.isLoadedNewKeys = true;
      let self = this;
      if (!this.fieldData.abbreviationLabelText) {
        let abbreviationLabelText = { english: " " };
        Object.assign(this.fieldData, { abbreviationLabelText });
      }
      if (!this.fieldData.labelForTable) {
        let labelForTable = { english: "" };
        Object.assign(this.fieldData, { labelForTable });
      }
      setTimeout(function () {
        self.isLoadedNewKeys = false;
      }, 1000);
    },

    addExtrasForHyperLink() {
      this.isLoadedNewKeys = true;
      let self = this;
      if (!this.fieldData.hyperLinkUrl) {
        let hyperLinkUrl = { english: " " };
        Object.assign(this.fieldData, { hyperLinkUrl });
      }
      if (!this.fieldData.hyperLinkText) {
        let hyperLinkText = { english: "" };
        Object.assign(this.fieldData, { hyperLinkText });
      }
      if (!this.fieldData.hyperLinkTextBefore) {
        let hyperLinkTextBefore = { english: "" };
        Object.assign(this.fieldData, { hyperLinkTextBefore });
      }
      if (!this.fieldData.hyperLinkTextAfter) {
        let hyperLinkTextAfter = { english: "" };
        Object.assign(this.fieldData, { hyperLinkTextAfter });
      }
      setTimeout(function () {
        self.isLoadedNewKeys = false;
      }, 1000);
    },

    tabClick(language) {
      let tempKey = language.toLowerCase();
      this.transalationLanguage = tempKey;
      this.label = this.fieldData.label[this.transalationLanguage];

      this.validationMessage = this.fieldData.validationMessage[
        this.transalationLanguage
      ];
      this.helperText = this.fieldData.helperText[this.transalationLanguage];

      // Conditional Field

      if (
        this.fieldData.inputType == "radio" ||
        this.fieldData.inputType == "select" ||
        this.fieldData.inputType == "checkbox"
      ) {
        this.conditionalFieldLabel = this.fieldData.conditionalFieldLabel[
          this.transalationLanguage
        ];
        this.conditionalFieldPlaceHolderText = this.fieldData.conditionalFieldPlaceHolderText[
          this.transalationLanguage
        ];

        this.conditionalFieldValidationMessage = this.fieldData.conditionalFieldValidationMessage[
          this.transalationLanguage
        ];
        this.conditionalFieldHelperText = this.fieldData.conditionalFieldHelperText[
          this.transalationLanguage
        ];
      }
    },

    onkeydown() {
      // onkeydown = "return event.keyCode => 48 && event.keyCode <= 57";
      return event.keyCode >= 48 && event.keyCode <= 57;
    },

    addNewKeyToOptions() {
      console.log("asasa----");
      let self = this;
      this.isLoadedNewKeys = true;

      let options = [...this.fieldData.options];
      options = options.map((opt) => {
        return {
          ...opt,
          weightage: opt.weightage ? opt.weightage : null,
          postValueAbb: opt.postValueAbb ? opt.postValueAbb : { english: "" },
          range: opt.range ? opt.range : null,
        };
      });
      Object.assign(this.fieldData, { options });
      setTimeout(function () {
        self.isLoadedNewKeys = false;
      }, 1000);
    },

    addLanguageToField(language) {
      let tempKey = language.toLowerCase();
      this.fieldData.label[tempKey] = this.label;
      this.fieldData.helperText[tempKey] = this.helperText;
      //  this.fieldData.validationMessage[tempKey] = this.langugeValidateMessage;
      this.fieldData.validationMessage[tempKey] = this.validationMessage;

      // Conditional Field
      if (
        this.fieldData.inputType == "radio" ||
        this.fieldData.inputType == "select" ||
        this.fieldData.inputType == "checkbox"
      ) {
        this.fieldData.conditionalFieldLabel[
          tempKey
        ] = this.conditionalFieldLabel;
        this.fieldData.conditionalFieldHelperText[
          tempKey
        ] = this.conditionalFieldHelperText;
        this.fieldData.conditionalFieldValidationMessage[
          tempKey
        ] = this.conditionalFieldValidationMessage;
        this.fieldData.conditionalFieldPlaceHolderText[
          tempKey
        ] = this.conditionalFieldPlaceHolderText;
      }
    },

    addAttributes() {
      let attributes = {
        newId: this.selectId ? this.selectId : undefined,
        Class: this.selectClass ? this.selectClass : undefined,
        Title: this.selectTitle ? this.selectTitle : undefined,
        Style: this.selectStyle ? this.selectStyle : undefined,
        readonly: this.selecReadOnly ? this.selecReadOnly : false,
        postName: this.selectedPostName ? this.selectedPostName : undefined,
      };
      Object.assign(this.fieldData, { attributes });
    },

    addRangesToSchema() {
      let ranges = [];
      Object.assign(this.fieldData, { ranges });
    },

    addOption() {
      let newOptiopn = {
        value: this.optionValue
          ? this.optionValue
          : this.fieldData.inputType +
            " value" +
            this.fieldData.options.length +
            1,
        text: {
          english: this.optiponName
            ? this.optionName
            : this.fieldData.inputType +
              " text " +
              this.fieldData.options.length +
              1,
        },
        score: 0,
      };

      // // console.log("newOptiopn", newOptiopn)
      this.fieldData.options.push(newOptiopn);
    },

    addRangeOption() {
      this.isRangeCreating = true;
      let data = {
        minRange: null,
        maxRange: null,
        score: null,
        id: null,
      };
      this.fieldData.ranges.push(data);
      this.isRangeCreating = false;
    },
    addColumnToOption() {
      if (this.newColData.key && this.newColData.key) {
        this.customColumnsForOptions.push(this.newColData);
        let options = [...this.fieldData.options];
        options = options.map((opt) => {
          return { ...opt, [this.newColData.key]: null };
        });
        Object.assign(this.fieldData, { options });
        this.fieldData.options.push(newOptiopn);
      }
    },
    addCustomKey() {
      let options = [...this.fieldData.options];
      options = options.map((opt) => {
        // if(opt.)
        return { ...opt, custom_values: {} };
      });
      Object.assign(this.fieldData, { options });
    },
    addColumnToOption() {
      if (this.newColData.key && this.newColData.key) {
        this.customColumnsForOptions.push(this.newColData);
        let options = [...this.fieldData.options];
        options = options.map((opt) => {
          return {
            ...opt,
            ...opt.custom_values,
            custom_values: {
              ...opt.custom_values,
              [this.newColData.key]: null,
            },
          };
        });
        Object.assign(this.fieldData, { options });
      }

      this.newColData = {
        text: null,
        key: null,
        desc: null,
      };
    },

    onDeleteCol(index) {
      // console.log("onDeleteCol", this.newColData);
      this.customColumnsForOptions.splice(
        this.customColumnsForOptions.indexOf(index),
        1
      );
    },

    setCustomColOptionsToSchema() {
      // console.log("customColumnsForOptions", this.customColumnsForOptions);
      let customColumnsForOptions = this.customColumnsForOptions;
      Object.assign(this.fieldData, { customColumnsForOptions });
    },

    getCustomColOptionsFromSchema() {
      if (
        this.fieldData.customColumnsForOptions &&
        this.fieldData.customColumnsForOptions.length
      ) {
        this.customColumnsForOptions = this.fieldData.customColumnsForOptions;
      }
    },

    addDataAttribute() {
      let newDataAttribute = {
        value: this.dataAttributeValue ? this.dataAttributeValue : undefined,
        key: this.dataAttributeKey
          ? "data-" + this.dataAttributeKey
          : undefined,
      };
      this.fieldData.dataAttributes.push(newDataAttribute);
    },

    onDeleteDataAttribute(index) {
      this.fieldData.dataAttributes.splice(
        this.fieldData.dataAttributes.indexOf(index),
        1
      );
    },

    onDeleteRange(index) {
      this.isRangeCreating = true;
      this.fieldData.ranges.splice(this.fieldData.ranges.indexOf(index), 1);
      this.isRangeCreating = false;
      customScoring;
    },

    onDeleteOption(index) {
      this.fieldData.options.splice(this.fieldData.options.indexOf(index), 1);

      // if (this.fieldData.options.length > 2) {
      // }
    },

    //methods for radio options settings
    setFieldOptionValue(value, optionIndex) {
      this.fieldData.options[optionIndex].value;
      this.optionValue = value;
      this.fieldData.options[optionIndex].value = value;
    },

    setFieldOptionText(value, optionIndex) {
      // this.form.formTitle[this.translationLanguage] = value;
      this.optiponName = value;
      this.fieldData.options[optionIndex].text[
        this.transalationLanguage
      ] = value;
    },
    /**
     * Required for validation on
     */
    setValidation() {
      let validation = {
        required: this.isRequireCheck,
        minSelect: this.minSelect,
        maxSelect: this.maxSelect,
      };
      Object.assign(this.fieldData, { validation });
    },

    setAdvanceSettingsForSelect() {
      this.fieldData.configuration = {
        isStacked: this.isStacked,
        isMultipleSelect: this.isMultipleSelect,
        isClearable: this.isClearable,
        isLiveSearchable: this.isLiveSearchable,
        minSelection: this.minSelection,
        maxSelection: this.maxSelection,
        renderOptionsLinmit: this.renderOptionsLinmit,
        // enableSelfReportingForThirdPartyProfile:
        //   this.fieldData.configuration
        //     .enableSelfReportingForThirdPartyProfile || false,
        // enableSelfReportingForManageThirdParty:
        //   this.fieldData.configuration.enableSelfReportingForManageThirdParty ||
        //   false
      };
      // Object.assign(this.fieldData, { advanceOption });
      // this.TOGGLE_LOADER(250);
    },

    // for conditional
    onToggleConditionalCheck(e) {
      if (e == 0) {
        // console.log("onToggleConditionalCheck", e);
        this.fieldData.selectedConditionalFieldValue = null;
        this.selectedConditionalFieldValue = null;
        this.selectedShowHide = null;
        this.selectedMutiInputs = 1;
      }
      this.showCollapseRadios = e == 1 ? true : false;
      this.enabledConditionalField = parseInt(e);
      this.fieldData.enabledConditionalField = parseInt(e);
    },

    onShowHideSelect(e) {
      this.fieldData.conditionalShowHiddenOption = parseInt(e); // 0 -> hide, 1 - > show
    },

    onSelectConditionOption(e) {
      // // console.log("eeee", e);
      this.fieldData.selectedConditionalFieldValue = this.selectedConditionalFieldValue;
      this.fieldData.selectedMutiInputs = this.selectedMutiInputs;
    },
    //for advance conditional
    getCurrentSectionList() {
      let conditionalSectionElements = this.form.formSection[this.sectionIndex]
        .formElements;
      conditionalSectionElements = conditionalSectionElements.filter(
        (element, index) => {
          if (
            element.inputType === "radio" ||
            element.inputType === "checkbox" ||
            element.inputType === "select"
          ) {
            // return element
            let dd = {
              label: element.label[this.transalationLanguage],
              element,
            };
            return this.conditionalSectionElementLables.push(dd);
          }
        }
      );
      this.conditionalSectionElements = conditionalSectionElements;
    },

    getSelectedElement(selectedElement) {
      this.selectedElementOption = [];
      this.conditionalFieldValue = null;
      selectedElement.element.options.map((opt) => {
        this.selectedElementOption.push(opt.value);
      });
    },

    setFieldConditions() {
      if (this.conditionalField && this.conditionalFieldValue) {
        let condition = {
          id: uid(),
          sourceFieldId: this.conditionalField.element.id,
          targetFieldId: this.fieldData.id,
          value: this.conditionalFieldValue,
          label: this.conditionalField.label,
        };
        let dd = {
          id: this.conditionalField.element.id,
          isActive: false,
          value: this.conditionalFieldValue,
        };
        let elements = [
          ...this.form.formSection[this.sectionIndex].formElements,
        ];
        elements = elements.map((element) => {
          if (element.options) {
            let found = element.options.map((opt) => {
              if (
                opt.value === this.conditionalFieldValue &&
                this.conditionalField.element.id === element.id
              ) {
                element.conditionalFields.push(condition);
              }
            });
          }
        });
        this.fieldData.isConditional = this.isConditional;
        this.fieldData.isHidden = true;
        // Object.assign(this.fieldData, { condition });
        this.fieldData.conditions.push(condition);
        this.conditionalFieldValue = null;
        this.conditionalField = null;
        Helper.makeToast(this.$bvToast, "success", "Conditional  Updated");
      } else {
        Helper.makeToast(this.$bvToast, "danger", "No Condition selected");
      }
    },

    onRemoveConditionOpt(optId, index) {
      if (optId && index !== -1) {
        this.fieldData.conditions.splice(index, 1);
      }
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
  },
};
</script>



        

        

